import React from "react";
import Select from "react-select";

// Custom styles for the Select component
const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: '#f9f9f9', // Apply background color
    borderColor: '#ddd', // Apply border color
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Ensure dropdown appears above other elements
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#666666', // Customize placeholder color
  }),
};

const GenderSelect = ({ value, onChange, name, isMulti }) => {
  const options = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "others", label: "Others" },
  ];

  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      name={name}
      isMulti={isMulti} // Pass the isMulti prop to enable multi-select
      styles={customStyles}
    />
  );
};


export default GenderSelect;
